import React, { useContext, useEffect, useState } from "react";
import Avatar from "../../VibehutUI/Avatar";
import { Link } from "react-router-dom";
import PasswordIcon from "../../VibehutUI/Icons/PasswordIcon";
import Polygon from "../../VibehutUI/Icons/Polygon";
import Subscriptions from "../../VibehutUI/Icons/Subscriptions";
import { StoreContext } from "../../Context/StoreContext";
import { checkMyRoomSubscription } from "../../utils/utils";
import NewTab from "../../VibehutUI/Icons/NewTab";

const getRoute = (conversation) => {
  if (conversation.isSubscriber) {
    return `/chat?roomId=${conversation.room._id}`;
  } else if (conversation.room.slug) {
    return `/${conversation.room.slug}`;
  } else {
    return `/rooms/${conversation.room._id}`;
  }
};

function LiveConversationCard({ conversation }) {
  const { state } = useContext(StoreContext);
  const {
    subscription: { mySubscriptions },
  } = state;
  const [isUserSubscribed, setIsUserSubscribed] = useState(false);
  useEffect(() => {
    const mySubscription = checkMyRoomSubscription(
      mySubscriptions,
      conversation?._id,
    );
    if (mySubscription) {
      setIsUserSubscribed(true);
    }
  }, [mySubscriptions, conversation?._id]);
  return (
    <Link to={getRoute(conversation)}>
      <>
        <div className="flex items-center gap-2.5 drop-shadow-md bg-frescoWhite p-2.5 rounded-2xl relative">
          <div className="-space-x-4 flex">
            {conversation.users?.map((user) => (
              <div
                className="border-3 rounded-full  border-frescoWhite z-10"
                key={user._id}
              >
                <div className="w-7 h-7 rounded-full">
                  <Avatar
                    src={user.profile.profile_picture}
                    username={user.profile.username}
                    size="xs"
                  />
                </div>
              </div>
            ))}

            <div className="border-3 rounded-full  border-frescoWhite z-10">
              <div class="typing-indicator w-7 h-7 flex items-center justify-center rounded-full  bg-navyGray gap-0.5">
                <span className="  rounded-full"></span>
                <span className="  rounded-full"></span>
                <span className="  rounded-full"></span>
              </div>
            </div>
          </div>
          <div className="flex flex-col  ">
            <span
              className={` text-darkNight font-medium text-sm flex items-baseline gap-0.5  ${
                conversation.room.promotion &&
                conversation.room.promotion.imgUrl &&
                "pr-[30%]"
              } `}
            >
              <span>
                {conversation.room.isPasswordProtected && (
                  <PasswordIcon height="20" width="20" />
                )}{" "}
                {conversation.room.isNftCollectionRoom && (
                  <Polygon
                    bgColor={
                      conversation.room.isAccessible ? "#FFCC00" : "#B5B5B5"
                    }
                    isInline={true}
                  />
                )}
                {conversation.room.hasSubscription && (
                  <Subscriptions
                    color={isUserSubscribed ? "#34C759" : "#7A7A7A"}
                  />
                )}
                {conversation.room?.desoPostRoom?.postHashHex && <>💎</>}
              </span>
              <span className="custom-two-line-clamp  ml-0.5">
                {conversation.room.name}
              </span>
            </span>
            <span className="text-darkGray text-xs">
              {conversation.chattingCount} chatting
            </span>
          </div>
          {conversation.room?.promotion &&
            conversation.room.promotion?.imgUrl && (
              <img
                src={conversation.room?.promotion.imgUrl}
                alt={conversation.room.promotion.title || "promotion"}
                className="max-w-[25%] object-fill overflow-hidden absolute h-full min-h-full right-0 rounded-br-2xl rounded-r-2xl"
              />
            )}
        </div>
        {conversation?.room?.promotion && (
          <div className="pt-1.5 font-normal text-xs text-center dark:text-frescoWhite text-darkGray flex items-end">
            Sponsored &#8226; {conversation.room.promotion?.title}
            <a
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="pt-1.5 ml-0.5 font-normal text-sm text-center dark:text-frescoWhite text-darkGray flex items-center"
              target="blank"
              href={conversation.room.promotion.link}
            >
              <NewTab ratio="14" />
            </a>
          </div>
        )}
      </>
    </Link>
  );
}

export default LiveConversationCard;
